<template>
  <!-- <router-link :to="{ name: 'course', params: { courseId: course.id } }"> -->
  <router-link :to="{ name: service.to }">
    <div class="card is-clickable has-text-centered">
      <div class="card-image">
        <figure class="image is-1by1">
          <img :src="service.thumb" :alt="service.title">
        </figure>
      </div>
      <div class="card-content">
        <h5 class="title is-4">{{ service.title }}</h5>
        <p>{{ service.description }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['service']
}
</script>

<style lang="scss">
.card-image{
  padding: 1rem 3rem 0 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceThumbnail.vue